import { feed as libraryFeed } from 'feed';
import Simmer from 'simmerjs';
import RestServices from '~/api';
import { ConfirmMessage } from '~/utils/EmbeddingFeed/ConfirmMessage';
import { UniversalEmbedding } from '~/utils/EmbeddingFeed/UniversalEmbedding';
import { getCurrentPlatformType } from '~/utils/getCurrentPlatformType';
import { Demonstration } from './Demonstration';

/**
 * Управляет процессом встраивания ленты рекомендаций на сайт клиента
 *
 * message - сообщение при выборе места встраивания
 * potentialSelector - селектор выбранного места вставки
 */
export class EmbeddingFeed extends UniversalEmbedding {
  message: HTMLDivElement = null;
  potentialSelector: string = null;
  demonstration: Demonstration;

  constructor() {
    super(getCurrentPlatformType() === 'desktop' ? 'desktop' : 'mobile');

    this.demonstration = new Demonstration();
  }

  /**
   * Закрывает вкладку
   * Если перед встраиванием изменить хеш на #test, то вкладка не закроется
   * это можно использовать для тестирования запроса feedSelector
   */
  successfulSendingSelector = (): void => {
    if (window.location.hash !== '#test') window.close();
  }

  /**
   * Сообщение об ошибке отправки запроса feedSelector
   * TODO переписать на новый логер
   * @param reject
   */
  failedSendingSelector = (reject: any): void => {
    console.log(
      `Не удалось сохранить селектор.
    Обновите страницу, чтобы попробовать еще раз.
    Текст ошибки: ${reject?.errorData?.errorText}`
    );
  }

  /**
   * Отправляет запрос на сохранение выбранного селектора при методе встраивания alternative
   */
  sendSelector = (): void => {
    const raker = [this.potentialSelector, ''];
    let [selector, selectorMobile] = raker;
    if (
      window.clickstreamAnalyticUtilities.EmbeddingFeed.platform === 'mobile'
    ) {
      [selectorMobile, selector] = raker;
    }
    RestServices.feedSelector
      .set(selector, selectorMobile)
      .then(this.successfulSendingSelector, this.failedSendingSelector);
  }

  /**
   * Запускает процесс встраивания повторно
   */
  restartEmbedding = () => {
    libraryFeed.killFeed(window.clickstreamAnalyticUtilities.EmbeddingFeed.feedId);
    this.start(this.embedding);
  }

  /**
   * Обрабатывает выбор пользователя в ConfirmMessage
   * @param statusSelection
   */
  processingUserSelection = (statusSelection: boolean) => {
    statusSelection ? this.sendSelector() : this.restartEmbedding();
  }

  /**
   * Завершает процесс встраивания ленты в зависимости от метода: 'standard' | 'alternative'
   * @param selector
   */
  completionEmbedding = (selector: string): void => {
    switch (window.clickstreamAnalyticUtilities.EmbeddingFeed.method) {
      case 'standard': {
        window.clickstreamAnalyticUtilities.EmbeddingFeed.eventSource.postMessage(
          {
            platform:
            window.clickstreamAnalyticUtilities.EmbeddingFeed.platform,
            selector,
          },
          '*'
        );
        this.stop();
        break;
      }
      case 'alternative': {
        this.stop();
        new ConfirmMessage(this.processingUserSelection).showConfirmMessage();
        break;
      }
    }
  }

  /**
   * Встраивает ленту-образец в выбранный пользователем блок
   * @param element - HTMLElement блок на сайте клиента
   */
  embedding = (element: HTMLElement): void => {
    const selector = new Simmer()(element);
    this.potentialSelector = selector;
    this.demonstration.start({
      selector,
      configuration:
      window.clickstreamAnalyticUtilities.EmbeddingFeed.configuration,
      feedId: window.clickstreamAnalyticUtilities.EmbeddingFeed.feedId,
    });
    this.completionEmbedding(selector);
  }

  /**
   * Активирует начало процесса встраивания - на странице появляется указатель
   */
  startEmbeddingFeed = () => {
    window.clickstreamAnalyticUtilitiesDemo = {
      isDemo: true,
      hash: window.location.hash,
    };
    this.start(this.embedding);
  }
}
